import { isStreamOneTimeTariff } from '../../tariffTypes'

/** Дефолтная цена разовой оплаты из first_price тарифа. */
export const getStreamOneTimeDefaultPrice = (
  tariff?: ICourseTariff | null,
): number => Math.max(0, Number(tariff?.first_price) || 0)

export { isStreamOneTimeTariff }
